export enum VivoxPlatform {
    SDKue4 = 'sdk.ue4',
    SDKv4 = 'sdk.v4',
    SDKv5 = 'sdk.v5',
}

export const vivoxPlatforms = [VivoxPlatform.SDKue4, VivoxPlatform.SDKv4, VivoxPlatform.SDKv5];
